import React from "react";
import { Logo } from "../assets/icons/Icons";
import { useUserData } from "../lib/contexts/UserContext";
import HospitalCard from "../components/HospitalCard";
import Loader from "../components/Loader";
import { useHospDocData } from "../lib/contexts/HospitalDoctorContext";
import { useNavigate } from "react-router-dom";

const ChooseDoctor = () => {
  const { userData } = useUserData();
  
  const { hospitalID, allDoctorsData, setDoctor } = useHospDocData();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const view = queryParams.get("view") || "clinic-and-scan-view";
  const navigateUrl = "/" + hospitalID + "/" + view;
  

//   useEffect(() => {
//     setDoctor(undefined);
//   }, []);

  return (
    <div className="flex flex-col w-full justify-center items-center pt-14 pb-40">
      <Logo />
      <p className="font-semibold text-dark text-lg md:text-2xl lg:text-3xl mt-16 mb-5">
        Choose a doctor
      </p>
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-7 mb-16">
        {/* Create constant */}
        {allDoctorsData?.map((doc) => (
          <HospitalCard
            key={doc.doctor_id}
            logo={doc.profile_picture}
            name={doc.full_name}
            specialization={doc.specialization}
            qualification={doc.qualification}
            gender={doc.gender}
            docCount={"none"}
            hide_from_tv={doc.hide_from_tv}
            show_name_prefix={doc.show_name_prefix !== false}
            handlePress={() => {
              console.log(doc.full_name);
              setDoctor(doc);
              navigate(navigateUrl);
            }}
          />
        ))}
      </div>
      {userData === undefined && <Loader />}
    </div>
  );
};

export default ChooseDoctor;
